import { useStyles } from './hooks/useStyles';
import TermDialog from '../../../../../components/old/ui/Dialog/TermDialog';
import { useCallback, useState } from 'react';
import { useGetCollections } from '../../hooks/useGetCollections';
import { Text, TextType } from '../../../../../components/base/Text';
import { colors } from '../../../../../constants/colors';
import { ICollection } from '../../../../../interfaces/collections';
import { IProductFilter } from '../../../../../interfaces/product';
import { useHistory } from 'react-router';

const Footer = () => {
  const classes = useStyles();
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState('user_agreement');
  const [collections] = useGetCollections('footer');
  const history = useHistory();

  const openDialog = useCallback((type: any) => {
    setDialogType(() => type);
    setDialogOpen(() => true);
  }, []);

  const clickCollection = useCallback((item: ICollection) => {
    const params: any = {};

    item.parameters.forEach((param) => {
      params[`parameter${param.parameter}`] = param.values;
    });
    const productsFilter: IProductFilter = {
      maxPrice: Number.isInteger(item.max_price) ? item.max_price.toString() : null,
      minPrice: Number.isInteger(item.min_price) ? item.min_price.toString() : null,
      params,
    };

    history.push(`/products/catalog/all`, { filter: productsFilter });
  }, []);

  return (
    <>
      <TermDialog
        contentType={dialogType}
        isOpen={isDialogOpen}
        handleClose={() => setDialogOpen(() => false)}
      />
      <div className={classes.footer}>
        <div className={classes.section1}>
          {/* <div className={classes.subscribeForm}>
            <span>
              Subscribe to the newsletter
            </span>
            <div>
              <Input placeholder="Enter your e-mail" />
              <Button text="Subscribe" light full />
            </div>
            <span>
              By clicking the "Submit" button you agree to the personal data processing policy
            </span>
          </div> */}
          <div className={classes.linksTable}>
            <div
              style={{
                display: 'inline-flex',
                flexDirection: 'column',
                maxWidth: 600,
                width: '90%',
                marginRight: 20,
              }}
            >
              <Text type={TextType.semiboldH5} color={colors.primary.white} margin={{ bottom: 24 }}>
                Categories
              </Text>

              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'flex-start',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                {collections.map((item: ICollection, index) => (
                  <Text
                    key={index}
                    type={TextType.semiboldButton}
                    color={colors.primary.white}
                    margin={{ bottom: 16 }}
                    style={{ cursor: 'pointer', width: '50%' }}
                    onClick={() => clickCollection(item)}
                  >
                    {item.name}
                  </Text>
                ))}
              </div>
            </div>

            <table>
              <tr>
                <th colSpan={2}>For partners</th>
              </tr>
              <tr>
                <td>
                  <a href="/auth/partner">Become a partner</a>
                </td>
              </tr>{' '}
              {/* <tr>
                <td>
                  <a href="#">To corporative clients</a>
                </td>
              </tr> */}
            </table>
          </div>
        </div>
        <div className={classes.section2}>
          <div>
            <span>© Flower Nation, inc.</span>
            <span onClick={() => openDialog('user_agreement')}> Conditions</span>
            <span onClick={() => openDialog('privacy_policy')}> Privacy policy</span>
            {/* <span>Site map</span> */}
          </div>
          {/* <div>
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.56485 0C2.03612 0 0 2.03612 0 4.56485V20.4352C0 22.9639 2.03612 25 4.56485 25H13.1664V15.2266H10.5821V11.7078H13.1664V8.70158C13.1664 6.3397 14.6934 4.1711 18.211 4.1711C19.6352 4.1711 20.6883 4.30783 20.6883 4.30783L20.6055 7.59378C20.6055 7.59378 19.5314 7.58363 18.3594 7.58363C17.0909 7.58363 16.8875 8.16807 16.8875 9.13832V11.7079H20.7063L20.5399 15.2266H16.8875V25.0001H20.4352C22.9639 25.0001 25 22.9639 25 20.4352V4.56488C25 2.03615 22.9639 2.5e-05 20.4352 2.5e-05H4.56483L4.56485 0Z"
                fill="white"
              />
            </svg>
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.77612 0.110254C7.998 0.0540039 8.38758 0.0415039 11.5001 0.0415039C14.6126 0.0415039 15.0022 0.0550456 16.223 0.110254C17.4438 0.165462 18.2772 0.360254 19.0063 0.642546C19.7699 0.931087 20.4626 1.38213 21.0355 1.96546C21.6188 2.53734 22.0688 3.229 22.3563 3.99359C22.6397 4.72275 22.8334 5.55609 22.8897 6.77484C22.9459 7.9988 22.9584 8.38838 22.9584 11.4998C22.9584 14.6123 22.9449 15.0019 22.8897 16.2238C22.8345 17.4425 22.6397 18.2759 22.3563 19.005C22.0688 19.7697 21.6181 20.4625 21.0355 21.0353C20.4626 21.6186 19.7699 22.0686 19.0063 22.3561C18.2772 22.6394 17.4438 22.8332 16.2251 22.8894C15.0022 22.9457 14.6126 22.9582 11.5001 22.9582C8.38758 22.9582 7.998 22.9446 6.77612 22.8894C5.55737 22.8342 4.72404 22.6394 3.99487 22.3561C3.23021 22.0685 2.53739 21.6178 1.96466 21.0353C1.38173 20.463 0.930618 19.7705 0.64279 19.0061C0.360498 18.2769 0.166748 17.4436 0.110498 16.2248C0.054248 15.0009 0.041748 14.6113 0.041748 11.4998C0.041748 8.38734 0.0552897 7.99775 0.110498 6.77692C0.165706 5.55609 0.360498 4.72275 0.64279 3.99359C0.931043 3.22909 1.3825 2.53662 1.96571 1.96442C2.53762 1.38161 3.22974 0.930507 3.99383 0.642546C4.723 0.360254 5.55633 0.166504 6.77508 0.110254H6.77612ZM16.1303 2.17275C14.922 2.11755 14.5595 2.10609 11.5001 2.10609C8.44071 2.10609 8.07821 2.11755 6.86987 2.17275C5.75216 2.2238 5.14591 2.41025 4.74175 2.56755C4.20737 2.77588 3.82508 3.02275 3.42404 3.4238C3.04388 3.79364 2.75131 4.24388 2.56779 4.7415C2.4105 5.14567 2.22404 5.75192 2.173 6.86963C2.11779 8.07796 2.10633 8.44046 2.10633 11.4998C2.10633 14.5592 2.11779 14.9217 2.173 16.13C2.22404 17.2478 2.4105 17.854 2.56779 18.2582C2.75112 18.755 3.04383 19.2061 3.42404 19.5759C3.79383 19.9561 4.24487 20.2488 4.74175 20.4321C5.14591 20.5894 5.75216 20.7759 6.86987 20.8269C8.07821 20.8821 8.43966 20.8936 11.5001 20.8936C14.5605 20.8936 14.922 20.8821 16.1303 20.8269C17.248 20.7759 17.8542 20.5894 18.2584 20.4321C18.7928 20.2238 19.1751 19.9769 19.5761 19.5759C19.9563 19.2061 20.249 18.755 20.4324 18.2582C20.5897 17.854 20.7761 17.2478 20.8272 16.13C20.8824 14.9217 20.8938 14.5592 20.8938 11.4998C20.8938 8.44046 20.8824 8.07796 20.8272 6.86963C20.7761 5.75192 20.5897 5.14567 20.4324 4.7415C20.224 4.20713 19.9772 3.82484 19.5761 3.4238C19.2063 3.04366 18.756 2.7511 18.2584 2.56755C17.8542 2.41025 17.248 2.2238 16.1303 2.17275ZM10.0365 15.0321C10.8539 15.3724 11.764 15.4183 12.6115 15.162C13.4589 14.9058 14.1911 14.3633 14.683 13.6272C15.1749 12.8911 15.396 12.007 15.3085 11.126C15.221 10.245 14.8303 9.42168 14.2032 8.79671C13.8035 8.39721 13.3201 8.09131 12.7879 7.90103C12.2558 7.71076 11.688 7.64084 11.1256 7.69631C10.5632 7.75179 10.02 7.93127 9.53529 8.22185C9.05056 8.51242 8.63627 8.90686 8.32227 9.37677C8.00827 9.84667 7.80236 10.3803 7.71937 10.9394C7.63638 11.4984 7.67836 12.0689 7.84231 12.6097C8.00626 13.1506 8.28808 13.6484 8.6675 14.0673C9.04691 14.4861 9.51448 14.8157 10.0365 15.0321ZM7.3355 7.33525C7.8824 6.78835 8.53166 6.35453 9.24622 6.05855C9.96078 5.76257 10.7266 5.61023 11.5001 5.61023C12.2735 5.61023 13.0394 5.76257 13.7539 6.05855C14.4685 6.35453 15.1178 6.78835 15.6647 7.33525C16.2116 7.88215 16.6454 8.53142 16.9414 9.24598C17.2374 9.96054 17.3897 10.7264 17.3897 11.4998C17.3897 12.2733 17.2374 13.0391 16.9414 13.7537C16.6454 14.4683 16.2116 15.1175 15.6647 15.6644C14.5601 16.7689 13.0621 17.3894 11.5001 17.3894C9.93806 17.3894 8.44001 16.7689 7.3355 15.6644C6.23098 14.5599 5.61047 13.0619 5.61047 11.4998C5.61047 9.93781 6.23098 8.43977 7.3355 7.33525ZM18.6959 6.48734C18.8314 6.35949 18.9399 6.20575 19.015 6.03523C19.09 5.8647 19.1301 5.68085 19.1328 5.49456C19.1355 5.30827 19.1008 5.12332 19.0308 4.95068C18.9608 4.77804 18.8568 4.6212 18.725 4.48946C18.5933 4.35772 18.4365 4.25375 18.2638 4.18371C18.0912 4.11367 17.9062 4.07898 17.7199 4.08169C17.5337 4.08441 17.3498 4.12448 17.1793 4.19952C17.0087 4.27457 16.855 4.38306 16.7272 4.51859C16.4785 4.78216 16.3424 5.13226 16.3477 5.49456C16.353 5.85686 16.4992 6.20284 16.7555 6.45905C17.0117 6.71526 17.3576 6.86153 17.7199 6.86682C18.0822 6.8721 18.4323 6.73597 18.6959 6.48734Z"
                fill="white"
              />
            </svg>
          </div> */}
        </div>
      </div>
    </>
  );
};
export default Footer;
